
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DefaultCharacterFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Character"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharacterFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharacterAttributes"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharacterProfile"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharacterSwatches"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharacterImages"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharacterUser"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharacterTheme"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featured_image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"large"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medium"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"style"},"value":{"kind":"StringValue","value":"medium","block":false}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cover_image_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"style"},"value":{"kind":"StringValue","value":"large","block":false}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lodestone_character"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LodestoneCharacterFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_listing"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount_cents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount_currency"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCharacterProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCharacterByUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultCharacterFields"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCharacterProfileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCharacter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultCharacterFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1131}};
    doc.loc.source = {"body":"#import 'fragments/CharacterFields.graphql'\n#import 'fragments/CharacterProfile.graphql'\n#import 'fragments/CharacterAttributes.graphql'\n#import 'fragments/CharacterSwatches.graphql'\n#import 'fragments/CharacterImages.graphql'\n#import 'fragments/CharacterUser.graphql'\n#import 'fragments/CharacterTheme.graphql'\n#import 'fragments/LodestoneCharacterFields.graphql'\n\nfragment DefaultCharacterFields on Character {\n  ...CharacterFields\n  ...CharacterAttributes\n  ...CharacterProfile\n  ...CharacterSwatches\n  ...CharacterImages\n  ...CharacterUser\n  ...CharacterTheme\n\n  featured_image {\n    url {\n      large\n    }\n  }\n\n  profile_image {\n    url {\n      medium\n    }\n  }\n\n  avatar_url(style: \"medium\")\n  cover_image_url(style: \"large\")\n\n  lodestone_character {\n    ...LodestoneCharacterFields\n  }\n\n  marketplace_listing {\n    id\n    amount_cents\n    amount_currency\n  }\n}\n\nquery getCharacterProfile($username: String!, $slug: String!) {\n  getCharacterByUrl(username: $username, slug: $slug) {\n    ...DefaultCharacterFields\n  }\n}\n\nquery getCharacterProfileById($id: ID!) {\n  getCharacter(id: $id) {\n    ...DefaultCharacterFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('fragments/CharacterFields.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('fragments/CharacterProfile.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('fragments/CharacterAttributes.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('fragments/CharacterSwatches.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('fragments/CharacterImages.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('fragments/CharacterUser.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('fragments/CharacterTheme.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('fragments/LodestoneCharacterFields.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCharacterProfile"] = oneQuery(doc, "getCharacterProfile");
        
        module.exports["getCharacterProfileById"] = oneQuery(doc, "getCharacterProfileById");
        
